// 全局tost this.$qmToast('HelloHello');
import { VueConstructor } from 'vue';
import QToast from './index.vue';

const QToastPlugin = {
    install(Vue: VueConstructor<Vue>) {
        Vue.component('QToast', QToast);

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let toastInstance: any = null;
        // 通过Vue的原型注册一个方法
        // 让所有实例共享这个方法 <br>    // 其中的duration是持续时间
        let timer = 0;
        Vue.prototype.$toast = (title: string, duration = 2000, type = 'default') => {
            if (!toastInstance) {
                // 生成一个Vue的子类
                const toastComponent = Vue.extend(QToast);
                // 生成一个该子类的实例
                // eslint-disable-next-line new-cap
                toastInstance = new toastComponent({
                    propsData: {
                        toast: false,
                        title: '',
                        type: '',
                    },
                });
                toastInstance.$mount();
                document.body.appendChild(toastInstance.$el);
            }

            toastInstance.$props.title = title;
            toastInstance.$props.type = type;
            toastInstance.$props.toast = true;

            timer && clearTimeout(timer);
            timer = setTimeout(() => {
                toastInstance!.$props.toast = false;
            }, duration);

            return toastInstance;
        };
    },
};
export default QToastPlugin;
